





























import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import { DataTableHeader } from "vuetify/types/index";
import { SortWarekiDate } from "#/utility/appSort";
import { toWarekiDatetime } from "#/utility/appDate";
import ItemTable from "#/components/ItemTable.vue";
import InfiniteLoading, { StateChanger } from "vue-infinite-loading";
import BaseRecord3List, {
  Record3ListItem
} from "@/components/list/baseRecord3List";

interface FormattedRecord3 extends Record3ListItem {
  created_at_wareki: string;
}

@Component({
  components: {
    ItemTable,
    InfiniteLoading
  }
})
export default class Record3List extends BaseRecord3List {
  @Prop({ default: "" }) private readonly patientId!: string;

  @Ref("infinite") private readonly infinite!: InfiniteLoading;

  private headers: DataTableHeader[] = [
    {
      text: "編集",
      value: "regist",
      sortable: false,
      width: "80px",
      align: "center"
    },
    {
      text: "訪問日",
      value: "target_date_wareki",
      width: "150px",
      sort: SortWarekiDate
    },
    {
      text: "レセプト事前チェック処理日",
      value: "created_at_wareki",
      width: "500px",
      sort: SortWarekiDate
    }
  ];

  @Watch("patientId")
  private onPatientIdChange(): void {
    this.resetLoaded();
  }

  /** 一覧と無限ローディングの状態をリセット */
  private resetLoaded(): void {
    this.resetRecord3List();
    if (this.infinite) {
      this.infinite.stateChanger.reset();
    }
  }

  /** 無限ローディングのローディング処理 */
  private infiniteHandler($state: StateChanger): void {
    const id = Number(this.patientId || this.$route.params.id);
    if (!id) {
      $state.complete();
      return;
    }
    this.fetchRecord3(id, fetchedCount => {
      if (fetchedCount < this.limit || this.records.length >= this.totalCount) {
        $state.loaded();
        $state.complete();
        return;
      }
      $state.loaded();
      this.page++;
    });
  }

  /** created_atを令和形式に整形 */
  private get formattedRecords(): FormattedRecord3[] {
    return this.records.map(r => ({
      ...r,
      created_at_wareki: toWarekiDatetime(r.created_at, true, true)
    }));
  }
}
